import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
} from "./utils/utils"
import { unique } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

// CONSTANTS
export const APPS_FETCHED = "APPS_FETCHED"
export const APP_CREATED = "APP_CREATED"
export const APP_UPDATED = "APP_UPDATED"
export const APP_REMOVED = "APP_REMOVED"
export const APP_SELECTED = "APP_SELECTED"

// API
class AppApi extends StackerAPI {
    path = "apps/"
}
const appApi = new AppApi()

class AppActions extends StackerActions {
    api = appApi
    reducer = "apps"
    actionTypes = {
        fetched: APPS_FETCHED,
        removed: APP_REMOVED,
        created: APP_CREATED,
        updated: APP_UPDATED,
    }
    selectApp = id => {
        return dispatch => {
            dispatch({ type: APP_SELECTED, id: id })
        }
    }
}
let AA = new AppActions()
AA.actions = { ...AA.actions, selectApp: AA.selectApp }
export const appActions = AA.actions

// STATE
const initialState = {
    apps: [],
    entities: {},
    fetching: [],
    selected: null,
}

// REDUCERS
export function appReducer(state = initialState, action) {
    var apps, app, fetching
    switch (action.type) {
        case APPS_FETCHED:
            return {
                ...state,
                apps: unique([...state.apps, ...action.payload.map(app => app._sid)]),
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case APP_CREATED:
            apps = [...state.apps, [action.payload._sid]]
            return {
                ...state,
                apps,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case APP_UPDATED:
            app = { ...state.entities[action._sid], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [app._sid]: app },
            }
        case APP_REMOVED:
            apps = state.apps.map(apps => without(apps, action._sid))
            return {
                ...state,
                apps,
            }
        case APP_SELECTED:
            return {
                ...state,
                selected: action.id,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }

        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getAppEntities = state => state.apps.entities
export const getApps = state => {
    if (typeof state.apps.apps.map !== "function") debugger
    return state.apps.apps.map(appId => state.apps.entities[appId])
}
export const getSelectedApp = state => state.apps.entities[state.apps.selected] || {}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/appApi.js